export const TEASER_PAGE_PATHNAME = '/teaser-page';
